import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What makes Flow State different from regular coffee?",
    a: "Flow State combines a premium-blend medium-dark roast with carefully selected natural compounds that help create a smoother, more balanced energy experience — clean stimulation without jitters or a crash.",
  },
  {
    q: "Will I taste anything unusual?",
    a: "No. Flow State tastes like an exceptional chocolate-and-nut profile coffee with low acidity. The natural compounds are blended so precisely they enhance the experience without interfering with the flavour.",
  },
  {
    q: "How much caffeine is in it?",
    a: "Roughly the same as a standard cup of coffee. The difference is in how the energy feels — steady and sustained rather than a quick spike.",
  },
  {
    q: "Is it suitable for every day?",
    a: "Yes. Flow State is designed as a daily drinker. The blend is built around balance, so it works equally well in the morning, before a focus session, or in the afternoon.",
  },
  {
    q: "How fresh is the coffee?",
    a: "Roasted in small batches and shipped within days of roasting. Store sealed in a cool, dry place for the best cup.",
  },
  {
    q: "What's the best way to brew it?",
    a: "It shines in any method — French press, espresso, pour-over or drip. For whole bean, a medium-fine grind works best for most brewers.",
  },
  {
    q: "Do you ship internationally?",
    a: "Yes, we ship across the UAE and to most international destinations. Free shipping applies to orders over 150 AED within the UAE.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <span className="text-[10px] tracking-[0.32em] uppercase text-[color:var(--fs-gold-muted)]">
            08 / FAQ
          </span>
          <h2
            className="mt-4 font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white"
            data-testid="faq-heading"
          >
            Questions,
            <br />
            <span className="italic text-gold-foil">answered.</span>
          </h2>
          <p className="mt-8 text-neutral-400 text-sm max-w-sm leading-relaxed">
            Curious about the blend? The brew? The experience? Start here.
          </p>
        </div>

        <div className="lg:col-span-7">
          <Accordion
            type="single"
            collapsible
            className="w-full"
            data-testid="faq-accordion"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="border-b border-[color:var(--fs-hairline)]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="font-display text-lg md:text-xl text-white py-6 hover:no-underline [&[data-state=open]>svg]:text-[color:var(--fs-gold-hi)]"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  className="text-sm md:text-base text-neutral-400 leading-relaxed pb-6 max-w-xl"
                  data-testid={`faq-content-${i}`}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
